// extracted by mini-css-extract-plugin
module.exports = {"App":"app_App__1w8Tx","App-logo":"app_App-logo__2NH6u","App-logo-spin":"app_App-logo-spin__tI3Nc","App-header":"app_App-header__3Yl2W","App-link":"app_App-link__3gGPU"};